module.exports = __webpack_public_path__ + "static/media/email-icon.83118c8f.webp";